import { useGraphqlQuery } from "graphql-mock"
import { Card, IconCertified } from "materia"
import { useTranslation } from "react-i18next"
import { backgroundImageStyle, modifiers } from "ui-tools"
import { getIsVideoUrl } from "../../../dataUtilities/getIsVideoUrl"
import { FiestaLink } from "utility-components"
import { HiddenHeader } from "../../../components/HiddenHeader"
import { Stars } from "../../../components/Stars"
import { query, type Progress } from "./gql"
import { JourneyTeaserError } from "./JourneyTeaserError"
import { JourneyTeaserSkeleton } from "./JourneyTeaserSkeleton"

import s from "./JourneyTeaser.module.scss"

export const JourneyTeaser = () => {
  const { data, error, isPending } = useGraphqlQuery(query, {})
  const { t } = useTranslation()

  if (isPending) return <JourneyTeaserSkeleton />
  if (error) return <JourneyTeaserError error={error} />

  const { nextJourney } = data
  if (!nextJourney) return

  const { backgroundImageUrl, title, progress, teaserImageUrl } = nextJourney
  const { starsCount, starsMax } = progress

  const backgroundImage = teaserImageUrl ?? backgroundImageUrl

  return (
    <Card>
      <HiddenHeader title={t("journey.CONTINUE_IN_JOURNEY")} tag="h2" />

      <FiestaLink className={modifiers(s, "teaser")} to="/journey">
        {backgroundImage && getIsVideoUrl(backgroundImage) ? (
          <video
            className={s.image}
            src={backgroundImage}
            muted
            playsInline
            preload="metadata"
            aria-hidden
            tabIndex={-1}
            onLoadedMetadata={(e) => {
              e.currentTarget.currentTime = 0.001
            }}
          />
        ) : (
          <div
            className={s.image}
            style={backgroundImageStyle(backgroundImage)}
          />
        )}

        <div className={s.gradient}>
          <h3 className={s.title}>{title}</h3>
          {progress && (
            <div className={s.stars} aria-hidden>
              <Stars count={1} max={1} size="extraSmall" />
              {starsCount}/{starsMax}
            </div>
          )}
          {progress && <Certified progress={progress} />}
        </div>
      </FiestaLink>
    </Card>
  )
}

const Certified = ({ progress }: { progress: Progress }) => {
  const { certifiedCount, certifiedMax } = progress

  return (
    <div className={s.certified} aria-hidden>
      <IconCertified title="Completed" />
      {certifiedCount}/{certifiedMax}
    </div>
  )
}
